import { Project } from "src/resources/api/project/types.api";

export const SDGData = [
  {
    goalNum: '1',
    title: 'No poverty',
    description: 'End poverty in all its forms everywhere',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483627/SDGS/Goal-01_sg97vs.png',
    },
  },
  {
    goalNum: '2',
    title: 'Zero hunger',
    description:
      'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-02_vymozz.png',
    },
  },
  {
    goalNum: '3',
    title: 'Good health and well-being',
    description: 'Ensure healthy lives and promote well-being for all at all ages',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-03_lt6igo.png',
    },
  },
  {
    goalNum: '4',
    title: 'Quality education',
    description:
      'Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-04_jy9dsk.png',
    },
  },
  {
    goalNum: '5',
    title: 'Gender equality',
    description: 'Achieve gender equality and empower all women and girls',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-05_yjci2g.png',
    },
  },
  {
    goalNum: '6',
    title: 'Clean water and sanitation',
    description: 'Ensure availability and sustainable management of water and sanitation for all',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-06_semty5.png',
    },
  },
  {
    goalNum: '7',
    title: 'Affordable and clean energy',
    description: 'Ensure access to affordable, reliable, sustainable and modern energy for all',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-07_fkx3wq.png',
    },
  },
  {
    goalNum: '8',
    title: 'Decent work and economic growth',
    description:
      'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-08_h2ldaz.png',
    },
  },
  {
    goalNum: '9',
    title: 'Industry, innovation and infrastructure',
    description:
      'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-09_bu6de9.png',
    },
  },
  {
    goalNum: '10',
    title: 'Reduced inequalities',
    description: 'Reduce inequality within and among countries',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-10_jsoop7.png',
    },
  },
  {
    goalNum: '11',
    title: 'Sustainable cities and communities',
    description: 'Make cities and human settlements inclusive, safe, resilient and sustainable',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-11_piejkd.png',
    },
  },
  {
    goalNum: '12',
    title: 'Responsible consumption and production',
    description: 'Ensure sustainable consumption and production patterns',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-12_r5lcnx.png',
    },
  },
  {
    goalNum: '13',
    title: 'Climate action',
    description: 'Take urgent action to combat climate change and its impacts',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483626/SDGS/Goal-13_kth7bm.png',
    },
  },
  {
    goalNum: '14',
    title: 'Life below water',
    description:
      'Conserve and sustainably use the oceans, seas and marine resources for sustainable development',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483627/SDGS/Goal-14_gacyrk.png',
    },
  },
  {
    goalNum: '15',
    title: 'Life on land',
    description:
      'Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483627/SDGS/Goal-15_nvvf3k.png',
    },
  },
  {
    goalNum: '16',
    title: 'Peace, justice and strong insititutions',
    description:
      'Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483627/SDGS/Goal-16_otdiec.png',
    },
  },
  {
    goalNum: '17',
    title: 'Partnerships for the goals',
    description:
      'Strengthen the means of implementation and revitalize the global partnership for sustainable development',
    image: {
      en: 'https://res.cloudinary.com/carbonclick/image/upload/v1644483627/SDGS/Goal-17_kczvaq.png',
    },
  },
];

export const getSustainableDevelopmentGoalData = (goal: number) => {
  return SDGData.find((item) => item.goalNum === String(goal));
};

export const getListOfUniqSDGs = (projects?: Project[]) => {
  const projectsSDGs = projects?.flatMap((el) => el?.sustainableDevelopmentGoals);
  if (projectsSDGs) {
    const uniqSDGs = [...new Map(projectsSDGs.map((item: any) => [item?.goalNum, item])).values()];
    const sortedArray = uniqSDGs?.sort((a, b) => +a?.goalNum - +b?.goalNum);
    return sortedArray;
  }
};
